import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class SearchRobinsonService {

    constructor(private api: ApiService) { }

    searchRobinson(portal: string, query: Object): Observable<any> {
        return this.api.get('vna/robinson/' + portal, query);
    }

    getAvailableCountries(): Observable<any> {
        return this.api.get('vna/robinson/available-countries');
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/robinson/search/services/search-robinson.service.ts